module.exports = __webpack_public_path__ + "img/mortgage-questions.b7ae944.webp";